import RandomPage from './random-page';

export default RandomPage;
